import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import { Card, Grid, Stack } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { ReactElement, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { WsButton, WsDrawer, WsTitleBanner, WsTypography, WsTypoVariants } from 'wisestep-base';

import { useWorkspaceContext } from '../../../../context';
import useJobsStore from '../../listing/hooks/useJobsStore';
import RecruitersList from '../components/RecruitersList';
import { defaultWorkAssignments } from '../types';

import BulkAssignCard from './components/BulkAssignCard';
import BulkJobDetailsCard from './components/BulkJobDetailsCard';
import TeamsListsTable from './components/TeamsListsTable';

const BulkJobsAssign = () => {
  const navigate = useNavigate();
  const navigateToListing = () => {
    updateSelectedJobs(null);
    navigate('/jobs');
  };
  const workspaceContext = useWorkspaceContext();
  const isVancyWorkspace = workspaceContext?.id == 'a61ed280-61fa-4e19-8e54-88bffcc24a75' ?? false;

  const jobs = useJobsStore((state) => state.jobs);
  const unSelectJob = useJobsStore((state) => state.removeSelectedJob);
  const updateSelectedJobs = useJobsStore((state) => state.updateSelectedJobs);
  const [openTeamsDrawer, setOpenTeamsDrawer] = useState<boolean>(false);
  const [openRecruitersDrawer, setOpenRecruitersDrawer] = useState<boolean>(false);

  const handleRecruitersDrawer = () => setOpenRecruitersDrawer(true);
  const handleTeamsDrawer = () => setOpenTeamsDrawer(true);

  const icons: ReactElement[] = [
    <GroupOutlinedIcon key={'Recruiters'} fontSize="large" color="action" />,
    <GroupsOutlinedIcon key={'Teams'} fontSize="large" color="action" />,
    <ContactPageOutlinedIcon key={'Partners'} fontSize="large" color="action" />,
  ];
  const jobIds = jobs.map((job) => job?.id ?? '');

  return (
    <>
      <WsTitleBanner title={'Assign Jobs'} goBack={navigateToListing} />
      {!isEmpty(jobs) ? (
        <Grid mt={3}>
          <Card sx={{ borderBottom: '1px solid #00B4D8' }}>
            {jobs.map((job, index) => (
              <BulkJobDetailsCard key={index} jobsData={job} onClick={() => unSelectJob(job)} />
            ))}
          </Card>
          <Grid item mt={6}>
            <WsTypography variant={WsTypoVariants.SUB_TITLE}>Assign Job to</WsTypography>
          </Grid>
          <Grid container item p={3}>
            <Grid item xs={12} m={2}>
              <Stack
                direction={'row'}
                justifyContent={`${isVancyWorkspace}` ? 'space-around' : 'space-between'}
              >
                {!isVancyWorkspace && (
                  <BulkAssignCard
                    icon={icons[0]}
                    name={'Recruiters'}
                    onClick={handleRecruitersDrawer}
                  />
                )}
                <BulkAssignCard icon={icons[1]} name="Teams" onClick={handleTeamsDrawer} />
                <BulkAssignCard icon={icons[2]} name="Partners" />
              </Stack>
            </Grid>
            <Grid container xs={12} mt={3} mr={5} justifyContent="flex-end">
              <WsButton variant="contained" size="large" onClick={navigateToListing}>
                Close
              </WsButton>
            </Grid>
          </Grid>
          <WsDrawer
            open={openTeamsDrawer}
            onClose={() => setOpenTeamsDrawer(false)}
            title="Teams"
            headerSize="medium"
            size="small"
          >
            <TeamsListsTable jobIds={jobIds} onAssign={() => setOpenTeamsDrawer(false)} />
          </WsDrawer>
          <WsDrawer
            open={openRecruitersDrawer}
            onClose={() => setOpenRecruitersDrawer(false)}
            title="Recruiters"
            headerSize="medium"
            size="small"
          >
            <Grid container p={3} mb={5}>
              <RecruitersList
                jobId={jobIds[0]}
                onAssign={() => setOpenRecruitersDrawer(false)}
                workAssignments={defaultWorkAssignments}
              />
            </Grid>
          </WsDrawer>
        </Grid>
      ) : (
        <WsTypography variant={WsTypoVariants.TITLE}>Please select jobs and come back</WsTypography>
      )}
    </>
  );
};

export default BulkJobsAssign;
